export const colors = {
    green: '#2FAD64',
    greenHover: '#239E58',
    greenActive: '#1b6d3b',
    grey: '#707070',
    blue: '#00b0f0',
};

